/**
 * Sy upp – "Snabb leverans" under the made-to-measure height
 * (snippets/sy-upp-addon.liquid)
 *
 * A curtain that also comes as a sy upp product ("<curtain> - måttanpassad
 * höjd": a ready length hemmed to the typed height, in about a week) shows a
 * box under its height field once the typed height is one sy upp can make:
 * "Snabb leverans +99 kr". Ticked, the customizer itself prices and adds the
 * sy upp product: this script registers it as an add-on with the
 * customizer's extension (assets/customizer-addons.js), which puts the fee
 * on the customizer's own total and sends the sy upp variant, with its
 * exact SKU, in the customizer's own cart request.
 *
 * So this script prices nothing and sends nothing. It decides when sy upp is
 * on (box ticked, typed height inside the sy upp variant's range) and says
 * so whenever the extension asks. The price, and whether a height can be
 * bought at all, stay the customizer's. On a tick it lets the customizer
 * recalculate by announcing the height field's value again, as typing does.
 * It also writes the box's delivery dates, and tells the section root, whose
 * delivery line (pdp.js) switches to sy upp's date.
 * Without the extension the box never shows.
 *
 * Delivery dates use the curtain page's own rule (deliveryEstimate in
 * pdp.js): today in Stockholm, past the cutoff hour
 * the next day, plus calendar days, moved forward to a business day. Made to
 * measure takes the payship block's days (21), sy upp 7.
 */
(() => {
  if (window.rdSyUpp) return;
  window.rdSyUpp = true;

  const SYUPP_DAYS = 7;

  /* ---------- delivery dates (the curtain page's rule) ---------- */

  function easter(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    return new Date(year, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
  }
  const holidayCache = {};
  const dayKey = (dt) => `${dt.getFullYear()}-${dt.getMonth()}-${dt.getDate()}`;
  function holidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    const e = easter(year);
    const off = (n) => new Date(year, e.getMonth(), e.getDate() + n);
    const list = [new Date(year, 0, 1), new Date(year, 0, 6), off(-2), off(1), new Date(year, 4, 1), off(39),
      new Date(year, 5, 6), new Date(year, 11, 24), new Date(year, 11, 25), new Date(year, 11, 26), new Date(year, 11, 31)];
    for (let day = 19; day <= 25; day++) {
      const cand = new Date(year, 5, day);
      if (cand.getDay() === 5) { list.push(cand); break; }
    }
    const set = {};
    list.forEach((dt) => { set[dayKey(dt)] = true; });
    return (holidayCache[year] = set);
  }
  const isBusinessDay = (dt) => dt.getDay() !== 0 && dt.getDay() !== 6 && !holidays(dt.getFullYear())[dayKey(dt)];
  function snapForward(from) {
    const r = new Date(from.getTime());
    while (!isBusinessDay(r)) r.setDate(r.getDate() + 1);
    return r;
  }
  function stockholmToday(cutoff) {
    let parts = null;
    try { parts = new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Stockholm' }); } catch (e) { /* old engine */ }
    const m = parts && parts.match(/^(\d{4})-(\d{2})-(\d{2})\D+(\d{2})/);
    const local = new Date();
    const date = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(local.getFullYear(), local.getMonth(), local.getDate());
    const hour = m ? +m[4] : local.getHours();
    if (cutoff > 0 && hour >= cutoff) date.setDate(date.getDate() + 1);
    return date;
  }
  /** A date in the page's language: "5 okt" on hastahome.se, "5.10." on .fi, "Oct 5" in English */
  const LANG = document.documentElement.lang || 'sv';
  function dateLabel(dt) {
    const options = { day: 'numeric', month: 'short' };
    let text;
    try { text = dt.toLocaleDateString(LANG, options); } catch (e) { text = dt.toLocaleDateString('sv-SE', options); }
    // Swedish short months carry a trailing period ("5 okt."); drop it, as the curtain page does
    return /^sv/i.test(LANG) ? text.replace(/\.$/, '') : text;
  }

  /** Sy upp's date and made to measure's, from the section's payship block */
  function deliveryDates(section) {
    const box = section.querySelector('[data-pdp-delivery]');
    const d = box ? box.dataset : {};
    const num = (v, fallback) => { const n = parseInt(v, 10); return Number.isNaN(n) ? fallback : n; };
    const start = stockholmToday(num(d.cutoff, 0));
    const plus = (n) => snapForward(new Date(start.getFullYear(), start.getMonth(), start.getDate() + n));
    return { syupp: plus(SYUPP_DAYS), mtm: plus(num(d.customMin, 21)) };
  }

  /* ---------- text ---------- */

  // `t` HTML-escapes translations inside the JSON; they are written as text
  const decode = (value) => new DOMParser().parseFromString(String(value || ''), 'text/html').documentElement.textContent;

  /**
   * A translation with [token]s filled in, as a fragment: the tokens named
   * in `bold` become <strong>, the rest plain text - never innerHTML, the
   * values come from the page.
   */
  function fill(template, values, bold = []) {
    const frag = document.createDocumentFragment();
    decode(template).split(/(\[[a-z_]+\])/).forEach((part) => {
      const token = part.match(/^\[([a-z_]+)\]$/);
      if (token && token[1] in values) {
        const text = String(values[token[1]]);
        if (bold.includes(token[1])) {
          const strong = document.createElement('strong');
          strong.textContent = text;
          frag.append(strong);
        } else {
          frag.append(text);
        }
      } else if (part) {
        frag.append(part);
      }
    });
    return frag;
  }

  /* ---------- the box ---------- */

  const dataCache = new WeakMap();
  function dataOf(box) {
    if (!dataCache.has(box)) {
      let data = null;
      try {
        data = JSON.parse(box.querySelector('[data-syupp-data]')?.textContent || 'null');
      } catch (e) {
        data = null;
      }
      dataCache.set(box, data);
    }
    return dataCache.get(box);
  }

  const wrapOf = (sectionId) => document.getElementById(`customizer-${sectionId}`);
  const boxOf = (sectionId) => wrapOf(sectionId)?.querySelector('[data-syupp]') || null;
  const heightFieldOf = (sectionId) => document.getElementById(`max-height-${sectionId}`);
  const isTicked = (box) => Boolean(box && box.querySelector('[data-syupp-check]')?.checked);

  /**
   * The typed height if sy upp can make it, else null. Read the way the
   * customizer reads it (parseFloat of the field), so both always agree on
   * which height is priced. The box only exists where the extension is
   * loaded; without it, sy upp is never offered.
   */
  function fittingHeight(box, sectionId) {
    const data = dataOf(box);
    const input = heightFieldOf(sectionId);
    if (!window.HastaCustomizerAddons || !data || !input) return null;
    const height = parseFloat(input.value);
    return Number.isFinite(height) && height >= data.min && height <= data.max ? height : null;
  }

  /** The add-on for the customizer's extension: asked on every calculation */
  function provider(sectionId) {
    const box = boxOf(sectionId);
    if (!isTicked(box) || fittingHeight(box, sectionId) === null) return null;
    const data = dataOf(box);
    return {
      variantId: data.id,
      fee: data.fee,
      fabric: data.fabric || '',
      shippingClass: data.shippingClass === true,
      width: data.width,
      error: decode(data.error)
    };
  }

  function paint(wrap) {
    const sectionId = wrap.id.slice('customizer-'.length);
    const section = document.getElementById(sectionId);
    if (!section) return;
    const box = wrap.querySelector('[data-syupp]');
    const height = box ? fittingHeight(box, sectionId) : null;

    if (box) {
      // hidden, the tick stays: typing 231 over 230 passes through "2" and "23"
      box.hidden = height === null;
      if (height !== null) {
        const dates = deliveryDates(section);
        box.querySelector('[data-syupp-sub]')?.replaceChildren(fill(dataOf(box).fits, {
          height, date: dateLabel(dates.syupp), mtm_date: dateLabel(dates.mtm)
        }, ['date']));
      }
    }

    const on = height !== null && isTicked(box);
    const was = section.classList.contains('rd-syupp-on');
    section.classList.toggle('rd-syupp-on', on);
    if (on) {
      section.dataset.syuppDays = String(SYUPP_DAYS);
      // a _html translation: `t` leaves its <strong> as markup
      section.dataset.syuppDelivery = dataOf(box).delivery || '';
    }
    if (on !== was) section.dispatchEvent(new CustomEvent('syupp:change', { detail: { on } }));
  }

  /**
   * After a tick the customizer has to recalculate with or without the fee.
   * It does that on input in its height field, so the field's own value is
   * announced once more, as typing does - the value stays the shopper's.
   */
  function recalculate(sectionId) {
    const input = heightFieldOf(sectionId);
    if (input && input.value !== '') input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  const onField = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.matches('[data-syupp-check]')) {
      if (event.type !== 'change') return;
      const wrap = input.closest('[id^="customizer-"]');
      if (!wrap) return;
      paint(wrap);
      recalculate(wrap.id.slice('customizer-'.length));
      return;
    }
    if (!input.id.startsWith('max-height-')) return;
    const wrap = wrapOf(input.id.slice('max-height-'.length));
    if (wrap && wrap.querySelector('[data-syupp]')) paint(wrap);
  };
  document.addEventListener('input', onField);
  document.addEventListener('change', onField);

  /**
   * The theme swaps the wrapper's content on every variant change: the box
   * comes back unticked, or not at all for a fixed height. Watched per
   * curtain section, since a page opened on a fixed height has no box yet.
   */
  const watched = new WeakSet();
  function watch(section) {
    const wrap = wrapOf(section.id);
    if (!wrap || watched.has(wrap)) return;
    watched.add(wrap);
    if ('MutationObserver' in window) {
      new MutationObserver(() => paint(wrap)).observe(wrap, { childList: true });
    }
    paint(wrap);
  }
  function boot() {
    if (window.HastaCustomizerAddons) window.HastaCustomizerAddons.register(provider);
    document.querySelectorAll('[data-pdp]').forEach(watch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
